// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ninput[type='radio'] {\n  margin: 0 5px 0 5px;\n}\n/* label {\n  margin-left: 5px;\n} */\n", ""]);
// Exports
module.exports = exports;
